var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "url(#paint0_linear_9_8027)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 59.5,
    height: 59.5,
    rx: 7.75,
    stroke: "#E6E6E6",
    strokeOpacity: 0.901961,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 27.75V30.5H22.625V27.75H25.375ZM30.875 27.75V30.5H28.125V27.75H30.875ZM36.375 27.75V30.5H33.625V27.75H36.375ZM39.125 18.125C39.8543 18.125 40.5538 18.4147 41.0695 18.9305C41.5853 19.4462 41.875 20.1457 41.875 20.875V40.125C41.875 40.8543 41.5853 41.5538 41.0695 42.0695C40.5538 42.5853 39.8543 42.875 39.125 42.875H19.875C18.3487 42.875 17.125 41.6375 17.125 40.125V20.875C17.125 20.1457 17.4147 19.4462 17.9305 18.9305C18.4462 18.4147 19.1457 18.125 19.875 18.125H21.25V15.375H24V18.125H35V15.375H37.75V18.125H39.125ZM39.125 40.125V25H19.875V40.125H39.125ZM25.375 33.25V36H22.625V33.25H25.375ZM30.875 33.25V36H28.125V33.25H30.875ZM36.375 33.25V36H33.625V33.25H36.375Z",
    fill: "#FCFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_8027",
    x1: 2.21774,
    y1: 30,
    x2: 60.121,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.1a7e965d81cf22f00f3f68e4ad8e8b5a.svg";
export { ForwardRef as ReactComponent };